/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Page from '@linc-technologies/linced-common/models/posts/page';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import PageAccessLevel from '@linc-technologies/linced-common/enums/page-access-level';
import StaffAccessLevel from '@linc-technologies/linced-common/enums/roles/staff-page-access';
import type Person from 'linced-app/models/person';
import type PostsTemplatesPage from 'linced-app/models/posts/templates/page';

// Proto: posts.Page.
export default class _Page extends Page {
  declare [Type]: 'posts/page';

  // Page meta
  @belongsTo('posts/templates/page', { async: true, inverse: null })
  declare pageTemplateId: AsyncBelongsTo<PostsTemplatesPage>;

  @alias('pageTemplateId')
  declare pageTemplate: AsyncBelongsTo<PostsTemplatesPage>;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  // Page content filters
  // assessmentIds/assessments are inherited from the addon's Page model
  // (assessments resolves to the loaded records, not the PromiseManyArray).

  @array('string')
  // @ts-expect-error a stored array replaces the common computed id list.
  declare assessment_ids: StatefulArray<string>;

  @computed('pageSets', 'pageSets.length')
  get numPageSets() {
    return this.get('pageSets.length') ?? 0;
  }

  // authorizedStaffAccessLevels returns page access level roles for staff members
  // allowed to access the page.
  @computed('accessLevel')
  get authorizedStaffAccessLevels() {
    // Staff with page access level set to "Access Control Level" or "Confidential"
    // would have access to page with any access level.
    const staffAccessLevels: EnumValue<typeof StaffAccessLevel>[] = [
      StaffAccessLevel.ACCESS_CONTROL_LEVEL,
      StaffAccessLevel.CONFIDENTIAL,
    ];
    switch (this.accessLevel) {
      case PageAccessLevel.SENSITIVE:
        staffAccessLevels.push(StaffAccessLevel.SENSITIVE);
        break;
      case PageAccessLevel.STANDARD:
        staffAccessLevels.push(
          StaffAccessLevel.SENSITIVE,
          StaffAccessLevel.STANDARD,
        );
        break;
    }
    return staffAccessLevels;
  }
}
